import QuestionCacheBox from './src/main.js'

export default QuestionCacheBox



// WEBPACK FOOTER //
// ./src/views/question-editor/components/question-cache-box/index.js